import { AbstractControl, ValidationErrors } from '@angular/forms';

export const email = (control: AbstractControl): ValidationErrors | null => {
  const key = 'email';

  const value = control.value;

  if (!value) return null;

  const result =
    // eslint-disable-next-line max-len
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      value
    );

  if (!result)
    return {
      [key]: true,
    };

  return null;
};
